<template>
    <div class="animated fadeIn">
        <b-card>
            <template v-slot:header>
                <h5>Kas Keluar</h5>
            </template>
            <b-form>
                <div class="form-content-wrapper">
                    <div v-if="fullAccess == 1">
                        
                        <b-form-group label="Cabang">
                            <b-form-checkbox 
                                v-model="input.allCabang"
                                name="allCabang"
                                class="mb-2"
                            >
                                Semua Cabang
                            </b-form-checkbox>
                            <div class="mr-2">
                                <multiselect
                                    name="cabang"
                                    :disabled=input.allCabang
                                    v-model="input.cabang" 
                                    :options="cabangOption" 
                                    :internal-search="true"
                                    :allow-empty="true"
                                    deselect-label=""
                                    select-label=""
                                    label="name"
                                    track-by="name"
                                    placeholder="-- Pilih Cabang --"
                                />
                            </div>
                        </b-form-group>
                    </div>
                    <b-form-group label="Cabang" v-else>
                        <div class="mr-2">
                            <multiselect
                                name="cabang"
                                v-model="input.cabang" 
                                :options="cabangOption" 
                                :internal-search="true"
                                :allow-empty="true"
                                deselect-label=""
                                select-label=""
                                label="name"
                                track-by="name"
                                placeholder="-- Pilih Cabang --"
                            />
                        </div>
                    </b-form-group>

                    <b-form-group class="small-input-date">
                        <b-form-radio v-model="dateType" value="harian">
                            <span>Harian</span>
                            <div class="d-flex search-input-wrapper">
                                <b-form-input class="mr-2" v-model="input.startDate" name="startDate" type="date" ></b-form-input>
                                <span class="mr-2 d-flex align-items-center">s/d</span>
                                <b-form-input v-model="input.endDate" name="endDate" type="date" ></b-form-input>
                            </div>
                        </b-form-radio>
                    </b-form-group>

                    <b-form-group class="small-select-date">
                        <b-form-radio v-model="dateType" value="bulanan">
                            <span>Bulanan</span>
                            <div class="d-flex">
                                <b-form-select class="mr-2 mb-2" v-model="input.bulan" id="inputBulan" name="inputBulan" :options="bulan" value-field="id" text-field="name">
                                    <template v-slot:first>
                                        <b-form-select-option :value="null" disabled>Bulan</b-form-select-option>
                                    </template>
                                </b-form-select>
                                <b-form-select v-model="input.tahun" id="inputTahun" name="inputTahun" :options="optionTahun">
                                    <template v-slot:first>
                                        <b-form-select-option :value="null" disabled>Tahun</b-form-select-option>
                                    </template>
                                </b-form-select>
                            </div>
                        </b-form-radio>
                    </b-form-group>
                </div>
                <div class="form-wrapper-btn">
                    <b-button name="viewLaporan" class="mr-2" variant="pgiBtn" @click="confirmLaporanWeb">Lihat di Web</b-button>
                    <b-button v-if="fullAccess == 1" name="downloadLaporan" variant="pgiBtn" @click="confirmLaporanDownload">
                        <i class="fa fa-download mr-2"></i>
                        Download Excel
                    </b-button>
                </div>
            </b-form>
        </b-card>

        <div v-if="showWebLaporan">
            <div class="text-center" v-if="isLoading">
                <b-spinner class="align-middle mb-4"></b-spinner>
                <p class="mb-0">Sedang memproses, mohon menunggu...</p>
            </div>
            <div v-else>
                <div class="mb-4 d-flex align-items-center justify-content-between laporan-periode-wrapper">
                    <div class="laporan-periode">
                        <h4>Laporan Kas Keluar</h4>
                        <h6>
                            Periode : 
                            <span v-if="periodeBulanan != null">{{periodeBulanan}}</span>
                            <span v-else>
                                <span>{{$helper.changeDateFormat(periodeStart)}}</span>
                                <span v-if="periodeEnd != ''"> - {{$helper.changeDateFormat(periodeEnd)}}</span>
                            </span>
                        </h6>
                    </div>
                </div>
                <b-card >
                    <template v-slot:header>
                        <h5>Laporan Kas Keluar Cabang</h5>
                    </template>
                    <b-table bordered hover show-empty
                        :busy="isBusy"
                        :items="dataLaporanKasKeluar" 
                        :fields="fields" 
                        responsive class="mb-3">
                        <template v-slot:table-busy>
                            <div class="text-center text-danger my-2">
                                <b-spinner class="align-middle"></b-spinner>
                                <strong>  Loading data...</strong>
                            </div>
                        </template>
                        <template v-slot:empty>
                            Tidak ada data kas keluar.
                        </template>
                        <template v-slot:cell(tanggal)="row">
                            {{ $helper.formatTimestampToDateTimeId(row.item.tanggalTimestamp) }}
                        </template>
                        <template v-slot:cell(jumlah)="row">
                            <div class="text-right no-wrap" v-if="row.item.jumlah !== null">Rp. {{$helper.addThousandSeparator(row.item.jumlah)}} </div>
                            <div class="text-right no-wrap" v-else>{{$helper.addThousandSeparator(row.item.jumlah)}} </div>
                        </template>
                    </b-table>
                </b-card>
            </div>
        </div>

        <ModalConfirm id="modal-confirm-cetak" title="Confirm Cetak Laporan Kas Keluar" :isSubmitting="isSubmitting" desc="Apakah anda yakin untuk mencetak laporan kas keluar ini?" @submit="openLaporanDownload" />
        <b-modal id="modal-download-excel" centered title="Download Excel" hide-footer no-close-on-backdrop>
            <div class="text-center" v-if="isLoading == true">
                <b-spinner class="align-middle mb-4"></b-spinner>
                <p class="mb-0">Sedang memproses, mohon menunggu...</p>
            </div>
            <div class="show-btn-download" v-else>
                <p class="">
                    Silakan download dengan klik tombol dibawah ini :
                </p>
                <b-button variant="pgiBtn" class="mb-0 download-btn">
                    <a v-bind:href="$baseFilePath + filePathDownload" download>
                        <i class="fa fa-download mr-2"></i>
                        Download Excel
                    </a>
                </b-button>
            </div>
        </b-modal>
    </div>
</template>

<script>
export default {
    name: 'kas-keluar',
    data(){
        return{
            isSubmitting: false,
            cabang: null,
            fullAccess: null,
            input: {
                allCabang: false,
                cabang: null,
                startDate: null,
                endDate: null,
                bulan: null,
                tahun: null
            },
            cabangOption: [],
            optionTahun: [],
            bulan: [
                { id: "1", name: "Januari" },
                { id: "2", name: "Februari" },
                { id: "3", name: "Maret" },
                { id: "4", name: "April" },
                { id: "5", name: "Mei" },
                { id: "6", name: "Juni" },
                { id: "7", name: "Juli" },
                { id: "8", name: "Agustus" },
                { id: "9", name: "September" },
                { id: "10", name: "Oktober" },
                { id: "11", name: "November" },
                { id: "12", name: "Desember" }
            ],
            dateType: "harian",

            //
            isLoading: false,
            filePathDownload: "",
            query: "",

            showWebLaporan: false,
            dataLaporanKasKeluar: [],
            fields: [
                { key: "tanggal", label: "Tanggal"},
                { key: "cabang", label: "Cabang"},
                { key: "jumlah", label: "Jumlah"},
                { key: "keterangan", label: "Keterangan"},
            ],
            isBusy: true,
            periodeStart: '',
            periodeEnd: '',
            periodeBulanan: null
        }
    }, 
    methods: {

        //----------------- Fungsi Inisialisasi -----------------

        init(){
            this.$axios.get('laporan/durasi-laporan').then(response => {
                this.fullAccess = response.data.id
				
				var thisYear = new Date().getFullYear()
				for(var i = 2016; i <= thisYear; i++) {
					this.optionTahun.push(i)
				}
                if(response.data.id != 1){
                    this.cabangOption = this.$helper.getAllCabang()
                }else{
                    this.$axios.get("cabang/all-selection").then(response => {
                        response.data.forEach((element) => {
                            this.cabangOption.push(element)
                        })
					})
                }
            })
        },

        confirmLaporanWeb(){
            if(this.input.allCabang == false && this.input.cabang == null){
                this.$helper.toastErr(this, "Mohon isi data cabang terlebih dahulu!")
            }else if(this.dateType == 'harian' && !this.$helper.isNotNullAndNotEmpty(this.input.startDate) || this.dateType == 'harian' && !this.$helper.isNotNullAndNotEmpty(this.input.endDate)){
                this.$helper.toastErr(this, "Mohon lengkapi periode harian untuk cetak laporan!")
            }else if((this.dateType == 'harian' && this.$helper.isNotNullAndNotEmpty(this.input.startDate) && this.$helper.isNotNullAndNotEmpty(this.input.endDate)) && (Date.parse(this.input.endDate) < Date.parse(this.input.startDate))){
                this.$helper.toastErr(this, "Tanggal akhir periode harian laporan lebih kecil daripada tanggal mulai!")
            }else if(this.dateType == 'bulanan' && this.input.bulan == null ||
                this.dateType == 'bulanan' && this.input.tahun == null){
                this.$helper.toastErr(this, "Mohon lengkapi periode bulan untuk cetak laporan!")
            }else{
                this.openLaporanWeb()
            }  
        },

        openLaporanWeb(){
            this.showWebLaporan = true
            this.isLoading = true
            setTimeout(() => { this.axiosLaporanWeb() }, 500)
        },

        axiosLaporanWeb(){
            if (this.dateType == 'harian'){
                if(this.input.cabang == null){
                    this.query = "?cabangId=0&startDate="+this.input.startDate
                                +"&endDate="+this.input.endDate+"&allCabang="+this.input.allCabang
                }else{
                    this.query = "?cabangId="+this.input.cabang.id+"&startDate="+this.input.startDate
                                +"&endDate="+this.input.endDate+"&allCabang="+this.input.allCabang
                }
          
                this.$axios.get(`laporan/kas-keluar/${this.query}`).then(response => {
                    this.dataLaporanKasKeluar = response.data
                    this.periodeStart = this.input.startDate
                    this.periodeEnd = this.input.endDate
                    this.periodeBulanan = null
                
                    this.isBusy = false
                })
                .catch(error => {
                    console.log(error)
                    this.$helper.toastErr(this, error.response.data.reason)
                    this.showWebLaporan = false
                    this.isLoading = false
                })
                .finally(() => {
                    this.isLoading = false
                })
            } else {
                if(this.input.cabang == null){
                    this.query = "?cabangId=0&month="+this.input.bulan
                                +"&year="+this.input.tahun+"&allCabang="+this.input.allCabang
                }else{
                    this.query = "?cabangId="+this.input.cabang.id+"&month="+this.input.bulan
                                +"&year="+this.input.tahun+"&allCabang="+this.input.allCabang
                }
                this.$axios.get(`laporan/kas-keluar/${this.query}`).then(response => {
                    this.dataLaporanKasKeluar = response.data
                    let idx = this.bulan.findIndex(item => item.id == this.input.bulan);
                    this.periodeBulanan = this.bulan[idx].name + ' '+ this.input.tahun
         
                    this.isBusy = false
                })
                .catch(error => {
                    console.log(error)
                    this.$helper.toastErr(this, error.response.data.reason)
                    this.showWebLaporan = false
                    this.isLoading = false
                })
                .finally(() => {
                    this.isLoading = false
                })
            }
        },

        confirmLaporanDownload(){
            if(this.input.allCabang == false && this.input.cabang == null){
                this.$helper.toastErr(this, "Mohon isi data cabang terlebih dahulu!")
            }else if(this.dateType == 'harian' && !this.$helper.isNotNullAndNotEmpty(this.input.startDate) || this.dateType == 'harian' && !this.$helper.isNotNullAndNotEmpty(this.input.endDate)){
                this.$helper.toastErr(this, "Mohon lengkapi periode harian untuk cetak laporan!")
            }else if((this.dateType == 'harian' && this.$helper.isNotNullAndNotEmpty(this.input.startDate) && this.$helper.isNotNullAndNotEmpty(this.input.endDate)) && (Date.parse(this.input.endDate) < Date.parse(this.input.startDate))){
                this.$helper.toastErr(this, "Tanggal akhir periode harian laporan lebih kecil daripada tanggal mulai!")
            }else if(this.dateType == 'bulanan' && this.input.bulan == null ||
                this.dateType == 'bulanan' && this.input.tahun == null){
                this.$helper.toastErr(this, "Mohon lengkapi periode bulan untuk cetak laporan!")
            }else{
                this.$bvModal.show("modal-confirm-cetak")
            }              
        },

        openLaporanDownload() {
            this.isLoading = true
            this.isSubmitting = true
            this.$bvModal.show('modal-download-excel')
            this.$bvModal.hide('modal-confirm-cetak')
            setTimeout(() => { this.axiosLaporanDownload() }, 500)
        },

        axiosLaporanDownload(){
            if (this.dateType == 'harian'){
                if(this.input.cabang == null){
                    this.query = "?cabangId=0&startDate="+this.input.startDate
                                +"&endDate="+this.input.endDate+"&allCabang="+this.input.allCabang
                }else{
                    this.query = "?cabangId="+this.input.cabang.id+"&startDate="+this.input.startDate
                                +"&endDate="+this.input.endDate+"&allCabang="+this.input.allCabang
                }
                this.$axios.get(`laporan/kas-keluar/dl/${this.query}`).then(response => {
                    this.filePathDownload = response.data
                })
                .catch(error => {
                    console.log(error)
                    console.log(error.response.data.reason)
                    this.$bvModal.hide('modal-download-excel')
                    this.$helper.toastErr(this, error.response.data.reason)
                })
                .finally(() => {
                    this.isSubmitting = false
                    this.isLoading = false
                })
            } else {
                if(this.input.cabang == null){
                    this.query = "?cabangId=0&month="+this.input.bulan
                                +"&year="+this.input.tahun+"&allCabang="+this.input.allCabang
                }else{
                    this.query = "?cabangId="+this.input.cabang.id+"&month="+this.input.bulan
                                +"&year="+this.input.tahun+"&allCabang="+this.input.allCabang
                }
                this.$axios.get(`laporan/kas-keluar/dl/${this.query}`).then(response => {
                    this.filePathDownload = response.data
                })
                .catch(error => {
                    console.log(error)
                    console.log(error.response.data.reason)
                    this.$bvModal.hide('modal-download-excel')
                    this.$helper.toastErr(this, error.response.data.reason)
                })
                .finally(() => {
                    this.isSubmitting = false
                    this.isLoading = false
                })
            }
        },
    },

    created(){
        this.init()
    }
}
</script>
